import React, {Component} from 'react';
import {connect} from "react-redux";

import PropTypes from 'prop-types';
import Countdown from "components/Countdown";
import {Alert} from "reactstrap";
import {setMinTimeValidate} from "reducers/page/actions";
import {FormattedMessage} from "react-intl";

class PageTimerMin extends Component {
  constructor(props){
    super(props);

    this.state = {
      countedDown: false,
      pageId: props.page.id,
    }
  }

  componentDidMount(){
    this.props.setMinTimeValidate(false);
  }

  updatePageId(){
    const {page} = this.props;

    this.props.setMinTimeValidate(false);
    this.setState({
      countedDown: false,
      pageId: page.id,
    })
  }

  handlerTimerCountedDown(){
    this.setState({
      countedDown: true
    }, () => {
      this.props.setMinTimeValidate(true);
    })
  }

  render() {
    const {countedDown} = this.state;
    const {time} = this.props;

    if(this.state.pageId !== this.props.page.id){
      this.updatePageId();
      return null;
    }

    if(countedDown){
      return <Alert color="success"><FormattedMessage id="pageTimerMin.allowNext"/></Alert>
    }

    return (
      <Alert color="warning">
        <span><FormattedMessage id="pageTimerMin.text"/> <FormattedMessage id="pageTimerMin.timeLeft"/>: <Countdown handlerTimerCountedDown={() => this.handlerTimerCountedDown()} time={time}/></span>
      </Alert>
    );
  }
}

PageTimerMin.propTypes = {
  time: PropTypes.number.isRequired,
  page: PropTypes.shape({
    id: PropTypes.number.isRequired,
    timeMin: PropTypes.number.isRequired,
  }).isRequired,
};

export default connect(null, {setMinTimeValidate})(PageTimerMin);